import classNames from "classnames/bind";
import type { ResolvedFeaturedFigures } from "resolvers/data/featuredFiguresResolver";
import styles from "./FeaturedFigures.module.scss";

const cx = classNames.bind(styles);

const FeaturedFigures = (props: ResolvedFeaturedFigures) => (
    <ul className={cx("featureFiguresList")}>
        {props.figures.map(({ figure, label }, i) => (
            <li className={cx("item")} key={i}>
                <span className={cx("figure")}>{figure}</span>
                <span className={cx("label")}>{label}</span>
            </li>
        ))}
    </ul>
);

export default FeaturedFigures;
